// extracted by mini-css-extract-plugin
export default {"generalModal":"Loading_generalModal__ObHrL","spinner":"Loading_spinner__ayu1j"};